module.exports = __webpack_public_path__ + "static/80e8c264.back.png";